<template>
  <div class="expert">
    <div class="search">
      <div class="search-input">
        <el-input
          placeholder="搜索专家姓名"
          v-model="epname"
          @keyup.enter.native="getExpertList(true)"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
      <div class="add" @click="toAddExpert(null)">
        <img src="../../assets/images/home/add-ico.png" alt="" />
      </div>
    </div>
    <div class="expert-list">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="expert-item" v-for="(ep, i) in expertList" :key="i">
          <div class="expert-infos">
            <img v-if="ep.head" :src="ep.head" alt="" />
            <img v-else src="../../assets/images/home/unuser_head.svg" alt="" />
            <div class="infos">
              <div>{{ ep.name }}</div>
              <p>
                <!-- <span v-for="(t, i) in ep.tags" :key="i">{{ t }} &nbsp;</span> -->
                {{ ep.tags }}
              </p>
            </div>
          </div>
          <div class="handle">
            <img
              src="../../assets/images/home/expert-edit-ico.png"
              @click="toAddExpert(ep.id)"
              alt=""
            />
            <img
              src="../../assets/images/home/expert-del-ico.png"
              @click="deleteConfirm(ep)"
              alt=""
            />
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import { getPageJudges, delUserJudges } from "@/utils/api/channel";
export default {
  data() {
    return {
      epname: "",
      loading: false,
      finished: false,
      page: 0,
      pageSize: 10,
      expertList: []
    };
  },
  methods: {
    onLoad() {
      this.page++;
      this.getExpertList(this.page === 1);
    },
    deleteConfirm(item) {
      this.$Dialog
        .confirm({
          title: "是否删除该专家",
          message: "如果该专家已参与点评，将不支持删除，请在后台禁用"
        })
        .then(() => {
          delUserJudges(item.id).then((res) => {
            if (res.success) {
              this.$root.$toast.success("删除成功");
              this.getExpertList(true);
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    getExpertList(init = false) {
      this.loading = true;
      if (init) this.expertList = [];
      const p = {
        pageNo: this.page,
        pageSize: this.pageSize,
        realName: this.epname
      };
      if (!this.epname) {
        delete p.realName;
      }
      getPageJudges(p).then((res) => {
        if (res.success) {
          const loadData = res.data.records.map((e) => {
            return {
              id: e.id,
              name: e.realName,
              tags: e.majors.split(",").join(" "),
              head: e.userImg
            };
          });
          this.expertList.push(...loadData);
        } else {
          this.loading = false;
          this.finished = true;
        }
        this.loading = false;
        if (this.page * this.pageSize >= res.data.total) {
          this.finished = true;
        }
      });
    },
    toAddExpert(id = null) {
      if (id)
        this.$router.push({
          path: "/channel/addexpert",
          query: {
            id,
            mode: 1
          }
        });
      else
        this.$router.push({
          path: "/channel/addexpert",
          query: {
            mode: 0
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.expert {
  height: 100%;
  width: 100%;
  .search {
    padding: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #f2f2f2;
    .search-input {
      width: 280px;
      height: 40px;
    }
    .add {
      width: 22px;
      height: 22px;
      i {
        font-size: 22px;
        color: #aaaaaa;
      }
    }
  }
  .expert-list {
    padding-bottom: 80px;
    .expert-item {
      height: 70px;
      // border-bottom: 1px solid #f2f2f2;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      .expert-infos {
        width: 80%;
        display: flex;
        align-items: center;
        img {
          height: 48px;
          width: 48px;
          margin-right: 15px;
          border-radius: 24px;
        }
        .infos {
          height: 48px;
          text-align: left;
          line-height: 22px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          max-width: 200px;
          p {
            max-width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          div {
            color: #666666;
            font-size: 14px;
            font-weight: 700;
            line-height: 22px;
          }
          p {
            color: #999999;
            line-height: 26px;
          }
        }
      }
      .handle {
        flex: 1;
        display: flex;
        justify-content: space-around;
        .van-button {
          min-width: 56px;
          border-radius: 5px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.expert {
  .search-input {
    .el-input {
      input {
        background-color: #f2f2f2;
        border: none;
        border-radius: 20px;
      }
    }
  }
}
</style>
